import { RichText } from '@wordpress/block-editor';

function Save({ attributes }) {
  const {
    linkText,
    linkUrl,
    size,
    backgroundColorClass,
    linkOnlyColorClass,
    ariaLabel,
  } = attributes;

  const isLinkOnly = size === 'link';

  // Determine class name based on whether it's a button or a link
  const baseClass = isLinkOnly
    ? `link-only ${linkOnlyColorClass}`
    : `button ${backgroundColorClass}`;

  // Determine class name based on size
  const sizeClass = isLinkOnly
    ? 'btn-link'
    : `btn btn-primary mdbtn ${size || 'btn-md'}`;

  return (
    <div>
      <a
        href={linkUrl}
        className={`${baseClass} ${sizeClass} btn-link`}
        aria-label={ariaLabel || undefined}
      >
        {linkText}
      </a>
    </div>
  );
}

export default Save;
